<tr class="linha" [class.selecionada]="selecionado" [class.expandida]="expandido" (click)="aoClicarNaLinha($event)">
  <td class="col-codigo">
    <div class="codigo-container">
      <button mat-icon-button class="botao-expandir" type="button"
        [matTooltip]="expandido ? 'Recolher' : 'Expandir'"
        [attr.aria-expanded]="expandido"
        (click)="$event.stopPropagation(); alternarExpansao.emit()">
        <mat-icon>{{ expandido ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
      <b class="codigo">{{ itemPesquisa.cdItem }}</b>
    </div>
  </td>
  <td class="col-descricao">
    <span class="descricao">{{ itemPesquisa.nmItem }}</span>
    @if (itemPesquisa.flPromocao && temEstoque) {
      <span class="selo-promocao" matTooltip="PROMOÇÃO">
        @if (temDesconto) { {{ itemPesquisa.pcDesconto | number:'1.0-1' }}% off } @else { PROMO }
      </span>
    }
    @if (temSimilares) {
      <mat-icon class="icone-similar" matTooltip="PRODUTO POSSUÍ SIMILARES" matTooltipPosition="above">filter_none</mat-icon>
    }
    @if (temRelacionados) {
      <mat-icon class="icone-similar" matTooltip="PRODUTO POSSUI RELACIONADOS" matTooltipPosition="above">link</mat-icon>
    }
  </td>
  <td class="col-marca">{{ itemPesquisa.nmMarca }}</td>
  <td class="col-unit">
    @if (precoDisponivel) {
      <div class="valor-unit">{{ valorUnitario | currency:'BRL' }}</div>
      <div class="info-pequena">({{ item.itemPedido.unMedVenda }})</div>
      @if (temDesconto) {
        <div class="info-pequena desconto">Desconto: {{ itemPesquisa.pcDesconto | number:'1.2-2' }}%</div>
      }
    } @else {
      -
    }
  </td>
  <td class="col-qtde">
    <app-quantidade-lista #qtd [modoTabela]="true" [item]="item"
      [quantidadeItemString]="quantidadeString"
      [temEstoque]="!item.itemDetalhes.estoqueDisponivel"
      [preco]="itemPesquisa.preco"
      [unMedVenda]="item.itemPedido.unMedVenda">
    </app-quantidade-lista>
  </td>
  <td class="col-total">
    @if (!precoDisponivel) {
      <span class="consulte" matTooltip="Consulte disponibilidade e valor com vendedor">Consulte</span>
    } @else if (quantidade > 0) {
      <b>{{ valorTotal | currency:'BRL' }}</b>
    }
  </td>
  <td class="col-acao">
    <ng-container *ngTemplateOutlet="qtd.tplAcoes"></ng-container>
  </td>
</tr>
@if (expandido) {
  <tr class="linha-detalhe" [class.selecionada]="selecionado">
    <td colspan="7">
      <div class="detalhe">
        <div class="detalhe-imagem">
          <img [src]="imagem" alt="Imagem do produto" (click)="openDialogDetalhes()">
          <div class="info-pequena">Unidade: {{ item.itemPedido.unMedVenda || item.itemDetalhes.unMedVendaPadrao }}</div>
        </div>

        <div class="detalhe-coluna detalhe-aplicacao">
          <div class="detalhe-titulo">Aplicação</div>
          @if (carregandoDetalhes && aplicacao.length === 0) {
            <mat-spinner diameter="20"></mat-spinner>
          }
          @for (grupo of aplicacaoVisivel; track $index) {
            @if (grupo.complemento) {
              <div class="aplicacao-complemento">{{ grupo.complemento }}</div>
            }
            @for (linha of grupo.linhas; track $index) {
              <div class="aplicacao-linha">{{ linha }}</div>
            }
          }
          @if (aplicacaoOcultas > 0) {
            <button type="button" class="texto-link aplicacao-mais" matTooltip="Ver todas as aplicações no item detalhado" (click)="openDialogDetalhes()">
              + {{ aplicacaoOcultas }} {{ aplicacaoOcultas === 1 ? 'aplicação' : 'aplicações' }}...
            </button>
          }
          @if (!carregandoDetalhes && aplicacao.length === 0) {
            <div class="info-pequena">Sem informações de aplicação.</div>
          }
        </div>

        <div class="detalhe-coluna detalhe-conversoes">
          <div class="detalhe-titulo">Conversões@if (conversoes.length > 0) {({{ conversoes.length }})}</div>
          @if (carregandoDetalhes && conversoes.length === 0) {
            <mat-spinner diameter="20"></mat-spinner>
          }
          <div class="conversoes-lista">
            @for (conversao of conversoes; track $index) {
              <span class="conversao" [matTooltip]="conversao.titulo + ': ' + conversao.descricao">
                <b>{{ conversao.codigo }}</b> {{ conversao.descricao }}
              </span>
            }
          </div>
          <div class="info-pequena cd-fabricante">Cd. Fabricante: {{ itemPesquisa.cdFabricante }}</div>
        </div>

        <div class="detalhe-coluna detalhe-acoes">
          <button (click)="openDialogDetalhes()" matTooltip="Item detalhado" color="primary" mat-mini-fab type="button">
            <mat-icon>touch_app</mat-icon>
          </button>
          @if (temSimilares) {
            <button (click)="abrirSimilares()" matTooltip="PRODUTO POSSUÍ SIMILARES" color="primary" mat-mini-fab type="button">
              <mat-icon>filter_none</mat-icon>
            </button>
          }
          @if (temRelacionados) {
            <button (click)="abrirSimilares('relacionados')" matTooltip="PRODUTO POSSUI RELACIONADOS" color="primary" mat-mini-fab type="button">
              <mat-icon>link</mat-icon>
            </button>
          }
          @if (!outrosPrecosIndisponivel) {
            <button (click)="listarPrecosDoItem()" matTooltip="Outros preços" color="primary" mat-mini-fab type="button">
              <mat-icon>currency_exchange</mat-icon>
            </button>
          }
          <button [matMenuTriggerFor]="ficha" matTooltip="Ficha técnica" color="primary" mat-mini-fab type="button">
            <mat-icon>assignment</mat-icon>
          </button>
          <mat-menu #ficha="matMenu">
            <div [innerHTML]="fichaTecnica" (click)="$event.stopPropagation()" class="fichaDescricao"></div>
          </mat-menu>
        </div>
      </div>
    </td>
  </tr>
}
